module.exports = __webpack_public_path__ + "static/media/phone.be2d1421.svg";